<template>
  <div class="queries-drawer elevation-1 card-border-right card-bg-3 mr-0" :class="{'mr-2' : drawer}" :style="drawer ? 'flex-basis: 300px;' : 'flex-basis: 0px;'">
    <ConfirmationDialog2 ref="confirmationDialog" />
    <v-layout>
      <v-subheader class="subheading primary--text">
        Saved Queries
      </v-subheader>
      <v-spacer />
      <v-btn @click="closeDrawer()" icon depressed>
        <v-icon>
          close
        </v-icon>
      </v-btn>
    </v-layout>

    <v-item-group mandatory v-model="filterToggle" active-class="white--text">
      <v-subheader style="display: inline; cursor: default;">Show:</v-subheader>
      <v-item :value="filterToggles.all">
        <v-chip small slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="chipFilter" @click="toggle">
          All
        </v-chip>
      </v-item>
      <v-item :value="filterToggles.shared">
        <v-chip small slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="chipFilter" @click="toggle">
          Shared
        </v-chip>
      </v-item>
      <v-item :value="filterToggles.self">
        <v-chip small slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="chipFilter" @click="toggle">My queries
        </v-chip>
      </v-item>
    </v-item-group>

    <v-divider />
    <v-list three-line class="py-0" dense :style="{ 'min-height': pagination.size * 77 + 'px' }">
      <v-list-tile v-if="loading.queries">
        <v-list-tile-content>
          <v-progress-circular color="info" class="mx-auto" indeterminate />
        </v-list-tile-content>
      </v-list-tile>
      <template v-else>
        <template v-for="(query, index) in queries">
          <v-list-tile :key="`query-${index}`" :disabled="loading.queryDetails" class="queries-list" :class="{'active-query-item': isSelectedQuery(query)}" @click="loadQuery(query)">
            <v-list-tile-content class="pl-2">
              <v-list-tile-title style="overflow: unset; display: flex;" :class="{ 'info--text': isSelectedQuery(query)}">
                <v-tooltip top :open-delay="600">
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="font-weight-medium">
                      {{ query.name }}
                    </div>
                  </template>
                  <span>
                    {{ query.name }}
                  </span>
                </v-tooltip>
                <v-spacer />
                <v-tooltip v-if="query.isShared" top :open-delay="600">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" class="pa-1" small>share</v-icon>
                  </template>
                  <span>
                    Query is shared
                  </span>
                </v-tooltip>
              </v-list-tile-title>
              <v-list-tile-sub-title style="overflow: hidden; height: 100%;">
                <div>
                  <div v-if="[filterToggles.shared, filterToggles.all].includes(filterToggle)" :class="{ 'blurry-text': !usersDetail[query.userId], 'teal--text': query.userId == userId }" class="caption">
                    {{ usersDetail[query.userId] ? usersDetail[query.userId].Username : query.userId }}
                  </div>
                  <div>
                    <v-tooltip bottom :open-delay="600">
                      <template v-slot:activator="{ on }">
                        <span v-on="on" class="font-weight-medium">
                          {{ formatDate(query.lastUpdated, dateFormats.prettyDateFormat) }}
                        </span>
                      </template>
                      <span>{{ formatDate(query.lastUpdated, dateFormats.prettyDateTimeFormat) }}</span>
                    </v-tooltip>
                    &mdash;
                    <v-tooltip v-if="query.description" right :open-delay="600">
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ query.description }}</span>
                      </template>
                      <span>{{ query.description }}</span>
                    </v-tooltip>
                    <span v-else>no description</span>
                  </div>
                </div>
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-divider vertical />
            <v-list-tile-content @click.stop style="flex: 0 0 35px;">
              <v-progress-circular v-if="query.loading" color="info" class="mx-auto" indeterminate />
              <v-menu v-else offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" :ripple="{ style: 'height: 100%; width: 100%;' }" tile class="ma-0 pa-0" block style=" height: 100%; min-width: 0;" flat>
                    <v-icon :color="isSelectedQuery(query) ? 'info' : ''">more_vert</v-icon>
                  </v-btn>

                </template>
                <v-list class="py-0">
                  <v-list-tile :disabled="!canRemove(query)" @click="confirmRemoveQuery(query)">
                    <v-list-tile-avatar>
                      <v-icon :color="canRemove(query) ? 'error' : ''">delete_forever</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>Remove</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider :key="`divider-${index}`" />
        </template>
        <v-list-tile v-if="queries && queries.length === 0" class="py-3 text-xs-center">
          <v-list-tile-content style="align-items: center;">
            <template v-if="filterToggle == filterToggles.shared">
              <v-icon>share</v-icon>
              <span>
                There are no shared queries yet.
              </span>
            </template>
            <template v-else>
              <v-icon>save</v-icon>
              <span>
                Save a query and it will show up here!
              </span>
            </template>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
    <Pagination v-model="pagination" />
  </div>
</template>

<script>
  import {
    prettyDateFormat,
    prettyDateTimeFormat,
  } from '@/components/mixins/MomentUtil'

  import moment from 'moment'
  import Pagination from './Pagination'

  const filterToggles = {
    all: 0,
    shared: 1,
    self: 2,
  }

  import { debounce } from '@/helpers/performance'
  import { changesNotSavedParam } from '@/helpers/multiStationQuery'
  import { createNamespacedHelpers } from 'vuex'
  const app = createNamespacedHelpers('app')

  const debounceTimer = 600

  const unknownError = (context) => context.$store.dispatch('app/setSnackbar', {
    text: 'Sorry, saved queries are not available right now. Please try again in a few minutes — let us know if it happens again!',
    color: 'error',
    icon: 'error',
  })

  const serviceUnavailable = (context) => context.$store.dispatch('app/setSnackbar', {
    text: 'Sorry, saved queries are not available right now. Please try again in a few minutes — let us know if it happens again!',
    color: 'error',
    icon: 'error',
  })

  export default {
    components: {
      Pagination,
    },
    props: {
      query: Object,
      drawer: Boolean,
      confirmOnLoad: Boolean,
    },
    data: () => ({
      pagination: {
        page: 0,
        size: 10,
        total: 0,
      },
      filterToggles,
      filterToggle: filterToggles.all,
      dateFormats: {
        prettyDateFormat,
        prettyDateTimeFormat,
      },
      loading: {
        queries: false,
        queryDetails: false,
      },
    }),
    computed: {
      reportGenerator() {
        return this.$store.getters['multistation/reportGenerator']
      },
      currentUser() {
        return this.$store.getters['authenticate/currentUser']
      },
      userId() {
        return this.currentUser && this.currentUser.userId
      },
      usersDetail() {
        return this.$store.getters['multistation/usersDetail']
      },
      queries() {
        return this.$store.getters['multistation/queries']
      },
      totalQueries() {
        return this.$store.getters['multistation/totalQueries']
      },
      debouncedUpdate() {
        return debounce(async function exec() {
          await this.fetchQueries()

        }, debounceTimer)
      },
    },
    watch: {
      totalQueries: {
        immediate: true,
        handler(value) {
          this.pagination.total = value
        },
      },
      drawer(value) {
        if (value) {
          this.fetchQueries()
        }
      },
      queries() {
        this.fetchQueryUsers()
      },
      'pagination.page'() {
        this.loading.queries = true
        this.debouncedUpdate()
      },
      filterToggle() {
        this.loading.queries = true
        this.debouncedUpdate()
      },
      isSomeAdmin() {
        return this.$store.getters['authenticate/isSomeAdmin']
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      canRemove(query) {
        return this.isCurrentUser(query) || this.isSomeAdmin
      },
      isCurrentUser(user) {
        if (!user) return true
        let userId = user.userId || user.UserId
        return this.currentUser.userId == userId
      },
      isSelectedQuery(query) {
        return this.query && this.query.id == query.id
      },
      async confirmRemoveQuery(query) {
        const params = {
          title: 'Remove query?',
          text: `This will remove the query '${query.name}'. <br/> It cannot be undone.`,
          confirmText: 'Remove',
          cancelText: 'Cancel',
          color: 'error',
          icon: 'delete_forever',
        }

        let confirmed = await this.$refs.confirmationDialog.confirm(params)
        if (!confirmed) return

        await this.removeQuery(query)
      },
      async removeQuery(query) {
        this.loading.queryDetails = true
        try {
          let service = this.reportGenerator
          if (!service) return serviceUnavailable(this)
          await this.$store.dispatch('multistation/removeQuery', {
            service,
            query,
          })

          await this.$nextTick()
        } catch (error) {
          console.error(error)
          this.setSnackbar({
            icon: 'error',
            text: error.displayMessage || error.reasonPhrase || error.Message || error.message || String(error),
            color: 'error',
          })
        }

        this.loading.queryDetails = false
        await this.fetchQueries()
      },
      formatDate(date, format) {
        return moment(date).format(format)
      },
      fetchQueries() {
        let service = this.reportGenerator
        if (!service) return serviceUnavailable(this)

        this.loading.queries = true
        return this.$store.dispatch('multistation/fetchQueries', {
          service,
          params: {
            from: this.pagination.from,
            size: this.pagination.size,
            filterToggle: this.filterToggle,
          },
        })
          .then(() => {
            this.loading.queries = false
          })
          .catch(() => {
            unknownError(this)
          })
      },
      async fetchQueryUsers() {
        let userIds = new Set()
        this.queries.forEach(query => userIds.add(query.userId))
        this.$store.dispatch('multistation/fetchUsersDetail', userIds)
      },
      async fetchQueryParams(query) {
        let service = this.reportGenerator
        if (!service) return serviceUnavailable(this)

        await this.$store.dispatch('multistation/fetchQuery', {
          service,
          query,
        })

        return this.queries.find(q => q.id == query.id)
      },
      async loadQuery(query) {
        this.loading.queryDetails = true

        if (this.confirmOnLoad) {
          let confirmed = await this.$refs.confirmationDialog.confirm(changesNotSavedParam)
          if (!confirmed) return
        }

        try {
          this.$store.dispatch('multistation/clearMissingParams')

          let updatedQuery = query
          if (!query.queryParams) {
            this.$set(query, 'loading', true)
            updatedQuery = await this.fetchQueryParams(query)
          }

          let parsedQuery = JSON.parse(JSON.stringify(updatedQuery))
          parsedQuery.queryParams = JSON.parse(parsedQuery.queryParams)

          let selection = parsedQuery.queryParams.selection
          let analyteNames = selection.analyteNames
          let stationIds = selection.stationIds
          let guidelineIds = selection.guidelineIds

          parsedQuery.queryParams.selection = {
            ...selection,
            analyteNames,
            stationIds,
            guidelineIds,
          }

          this.$emit('load:query', parsedQuery)
        } catch (error) {
          this.$set(query, 'loading', false)
          console.error(error)
          this.setSnackbar({
            icon: 'error',
            text: error.displayMessage || error.Message,
            color: 'error',
          })
        } finally {
          this.loading.queryDetails = false
        }
      },
      closeDrawer() {
        this.$emit('update:drawer', false)
      },
    },
  }
</script>

<style>
  .queries-drawer {
    overflow: hidden;
    min-width: 0;
    transition: flex-basis .45s ease-in-out, margin .45s ease-in-out;
    flex-shrink: 0;
  }

  .query-list {
    border-left: 2px solid transparent;
    transition: border-left .5s ease-in-out;
  }

  .active-query-item {
    background: #e3e3e3;
    border-left: 2px solid #2196f3;
  }

  .queries-list>a {
    padding-left: 0px;
    padding-right: 0px;
  }

  .blurry-text {
    color: transparent;
    animation: blur 2.5s ease-in infinite;
  }

  @keyframes blur {
    0% {
      text-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
    }

    50% {
      text-shadow: 0 0 5px rgba(0, 0, 0, 0.8);
    }

    100% {
      text-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
    }
  }
</style>